import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Services, WhyUs, Events, News, Features, Partners } from '../../sections';


const HomePage = () => {

  return (
    <div className='homepage'>

      <Home />              {/* Baner na samym pocz�tku */}
      <Features />          {/* G��wne cechy dworu */}
      <About />             {/* Kr�tkie streszczenie histori */}
      <Counter />           {/* Liczniki do historii */}
      <Services />          {/* Services section listing available offerings */}
      <WhyUs />             {/* Nasza wizja dotycz�ce artyku��w */}
      <News />              {/* Aktualno�ci : o nas w mediach */}
      <Events />            {/* Upcoming events or activities */}
      <Partners />          {/* Partnerzy loga*/}

    </div>
  )
}

export default HomePage;